<script>
    import {fade} from 'svelte/transition'
    export let question
</script>

<h1 class="question" in:fade="{{ duration: 500 }}">
    {@html question}
</h1>